const Dashboard = resolve => {
    require.ensure(["./components/pages/dashboard/Dashboard.vue"], () => {
        resolve(require("./components/pages/dashboard/Dashboard.vue"))
    })
}
const Survey = resolve => {
    require.ensure(["./components/pages/survey/Survey.vue"], () => {
        resolve(require("./components/pages/survey/Survey.vue"))
    })
}
const Properties = resolve => {
    require.ensure(["./components/pages/property/List.vue"], () => {
        resolve(require("./components/pages/property/List.vue"))
    })
}
const Property = resolve => {
    require.ensure(["./components/pages/property/Edit.vue"], () => {
        resolve(require("./components/pages/property/Edit.vue"))
    })
}
const Activations = resolve => {
    require.ensure(["./components/pages/activation/List.vue"], () => {
        resolve(require("./components/pages/activation/List.vue"))
    })
}
const Activation = resolve => {
    require.ensure(["./components/pages/activation/Edit.vue"], () => {
        resolve(require("./components/pages/activation/Edit.vue"))
    })
}
const Users = resolve => {
    require.ensure(["./components/pages/user/List.vue"], () => {
        resolve(require("./components/pages/user/List.vue"))
    })
}
const User = resolve => {
    require.ensure(["./components/pages/user/Edit.vue"], () => {
        resolve(require("./components/pages/user/Edit.vue"))
    })
}
const RateCards = resolve => {
    require.ensure(["./components/pages/settings/RateCards.vue"], () => {
        resolve(require("./components/pages/settings/RateCards.vue"))
    })
}
const CustomAssets = resolve => {
    require.ensure(["./components/pages/user/CustomAssets.vue"], () => {
        resolve(require("./components/pages/user/CustomAssets.vue"))
    })
}
const Assets = resolve => {
    require.ensure(["./components/pages/settings/Assets.vue"], () => {
        resolve(require("./components/pages/settings/Assets.vue"))
    })
}
const Settings = resolve => {
    require.ensure(["./components/pages/settings/Setting.vue"], () => {
        resolve(require("./components/pages/settings/Setting.vue"))
    })
}

const routes = [
    { path: "/", alias: "/dashboard", name: "dashboard", component: Dashboard, meta: { login_required: true } },
    { path: "/survey", name: "survey", component: Survey, meta: { login_required: true } },
    { path: "/properties", name: "property.list", component: Properties, meta: { login_required: true } },
    { path: "/property/:id", name: "property.edit", component: Property, meta: { login_required: true } },
    { path: "/activations", name: "activation.list", component: Activations, meta: { login_required: true } },
    { path: "/activation/:id", name: "activation.edit", component: Activation, meta: { login_required: true } },
    { path: "/custom-assets", name: "custom-assets", component: CustomAssets, meta: { login_required: true } },
    { path: "/users", name: "user.list", component: Users, meta: { admin_route: true } },
    { path: "/user/:id", name: "user.edit", component: User, meta: { login_required: true } },
    { path: "/user/:id/survey", name: "user.survey", component: Survey, meta: { login_required: true } },
    { path: "/profile", name: "profile", component: User, meta: { login_required: true } },

    { path: "/rate-cards", name: "rate-cards", component: RateCards, meta: { admin_route: true } },
    { path: "/assets", name: "assets", component: Assets, meta: { admin_route: true } },
    { path: "/settings", name: "settings", component: Settings, meta: { admin_route: true } }
]

export default routes
